// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footer__container":"Footer_footer__container__NV8sM","social__media":"Footer_social__media__fwLkj"};